import React, { useEffect, useState } from 'react';
import i18n from './i18n';
import Home from './screens/Home/Home';
import { useAppSelector } from './store/hooks';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ArticleShareData, decryptArticleData  } from './utils/encrypt';
import ShareableArticle from './components/ShareableArticle/ShareableArticle';

const theme = createTheme({
    direction: 'rtl',
  });

const App: React.FC = () => {
    const language = useAppSelector(state => state.main.language);
        const [sharedArticleData, setSharedArticleData] = useState<ArticleShareData | null>(null);

    React.useEffect(() => {
        const dir = i18n.dir(language);
        document.documentElement.dir = dir;
        i18n.changeLanguage(language);
      }, [language]);

    useEffect(() => {
        console.log("We are here App.tsx");
        const urlParams = new URLSearchParams(window.location.search);
        const encryptedData = urlParams.get('a');
        console.log("URLPARAMS: ", encryptedData);
        if (encryptedData) {
            const articleData = decryptArticleData(encryptedData);
            console.log("decryptArticleData: ", articleData);
            if (articleData) {
                setSharedArticleData(articleData);
            }
        }
    }, []);
      
    return (
        <ThemeProvider theme={theme}>
            {sharedArticleData ? (
                <ShareableArticle 
                    articleData={sharedArticleData}
                    isHeader={sharedArticleData.isHeader}
                />
            ) : (
                <Home />
            )}
        </ThemeProvider>
    );
};

export default App;
